/**
 * @description Fetch JSON from the Drupal API, checking the HTTP status and
 * retrying transient failures. The API answers an occasional empty 500 (~2% of
 * calls); without a retry a single one leaves the map blank until the visitor
 * reloads the page.
 * @param {string} url Endpoint to call.
 * @param {{retries?: number, delay?: number}} options Attempt count and the
 * base delay in ms, doubled between attempts.
 * @returns {Promise<any>} The parsed JSON payload.
 */
export const fetchJson = async (url, { retries = 3, delay = 500 } = {}) => {
  let lastError;

  for (let attempt = 0; attempt < retries; attempt += 1) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`${url} responded with HTTP ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      lastError = error;

      if (attempt < retries - 1) {
        await new Promise((resolve) =>
          setTimeout(resolve, delay * 2 ** attempt)
        );
      }
    }
  }

  throw lastError;
};
